import React from "react";
import "./Simmer.css"; // custom css

export default function Simmer({ size = 50 }) {
  return (
    <div className="simmer-search">
      <div className="magnifier" style={{ width: size, height: size }}>
        <div className="handle"></div>
      </div>
    </div>
  );
}